import React from "react";

// Example PDF links (replace these with your actual PDF URLs)
const pdfLinks = {
    "Alt-Doc - Activator": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/Accelerator-Activator Alt Doc.pdf",
    "Full-Doc - Activator": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/Accelerator-Activator Full Doc.pdf",
    "ITIN Full/Alt-Doc - Activator": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/ITIN Activator Alt Doc.pdf ",
    "Foreign National Full/Alt-Doc - Ambassador": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/FN-Ambassador-2nd-Full-Alt.pdf",

    "DSCR - DSCR Equity First": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website%20-%20Guidelines%20(2025)/Equity%20First.pdf",
    "DSCR 1-4 Unit - Accelerator": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/Accelerator 1-4 Units.pdf",
    "DSCR 5-8 Unit - Accelerator": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/Accelerator 5-8 Units.pdf",
    "Alt-Doc - Accelerator": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/Accelerator-Activator Alt Doc.pdf",
    "Full-Doc - Accelerator": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/Accelerator-Activator Full Doc.pdf",
    "ITIN DSCR - Accelerator": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/ITIN DSCR.pdf",
    "Foreign National DSCR - Ambassador": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/FN-Ambassador-DSCR.pdf",
    "Foreign National Full/Alt-Doc - Ambassador": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Website - Guidelines (2025)/FN-Ambassador-2nd-Full-Alt.pdf",
    "Seller Guide": "https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/3-16-26%20Correspondent%20Seller%20Guide.pdf"
};

const matrices = [
    {
        title: "Primary Residence & Second Homes",
        items: [
            "Alt-Doc - Activator",
            "Full-Doc - Activator",
            "ITIN Full/Alt-Doc - Activator",
            "Foreign National Full/Alt-Doc - Ambassador"
        ],
    },
    {
        title: "Investment Properties",
        items: [
            "DSCR - DSCR Equity First",
            "DSCR 1-4 Unit - Accelerator",
            "DSCR 5-8 Unit - Accelerator",
            "Alt-Doc - Accelerator",
            "Full-Doc - Accelerator",
            "ITIN DSCR - Accelerator",
            "Foreign National DSCR - Ambassador",
            "Foreign National Full/Alt-Doc - Ambassador",
        ],
    },
];

const guidelines = [
    {
        title: "Section 1",
        items: [
            {
                label: "Seller Guide",
                subItems: [
                    "Everything you need to know about being a correspondent seller"
                ],
            }
        ],
    },
];

const openPdf = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
};

const alwaysLink = [
    'Super Jumbo Full/Alt-Doc',
    'Seller Guide'
];
function splitBoldNormal(text) {
    // Special case: always hyperlink these
    if (alwaysLink.includes(text)) {
        return { bold: null, normal: text, forceLink: true };
    }
    // Split at last ' - ' (space-dash-space)
    const idx = text.lastIndexOf(' - ');
    if (idx === -1) return { bold: text, normal: null };
    return {
        bold: text.slice(0, idx),
        normal: text.slice(idx + 3)
    };
}

const CorrespondentMatrices = () => (
    <div
        style={{
            width: '100%',
            fontFamily: 'ProximaNova-Regular, Helvetica, Arial, SansSerifFLF, sans-serif',
            color: '#23272f',
            marginTop: '40px',
        }}
    >
        <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', marginBottom: 32 }}>
            {/* Matrices Tile */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 520, paddingTop: '32px' }}>
                <h2 style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '2.5rem', margin: 0, letterSpacing: 0.5, lineHeight: 1.1 }}>
                    Correspondent Matrices
                </h2>
                <div
                    style={{
                        background: '#fff',
                        borderRadius: '24px',
                        boxShadow: '0 2px 16px #0001',
                        padding: '32px',
                        minWidth: '420px',
                        marginTop: 16,
                        // no width: 100% or boxSizing here, keep original card size
                    }}
                >
                    <div style={{ display: 'flex', gap: '40px', marginTop: '24px' }}>
                        {matrices.map((section) => (
                            <div key={section.title}>
                                <h3 style={{ fontWeight: "bold", fontSize: "1.2rem" }}>{section.title}</h3>
                                <ul style={{ listStyle: "none", padding: 0, color: '#23272f' }}>
                                    {section.items.map((item) => (
                                        <li key={item} style={{ margin: "12px 0", display: "flex", alignItems: "center" }}>
                                            <img src="/content/Images/guidelinedoc.svg" alt="doc" style={{ marginRight: "12px", width: 26, height: 26, display: 'inline-block', verticalAlign: 'middle' }} />
                                            <a
                                                href={pdfLinks[item]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="matrix-link"
                                                style={{ fontWeight: 600 }}
                                            >
                                                {item}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Guidelines Tile */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 520, paddingTop: '32px' }}>
                <h2 style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '2.5rem', margin: 0, letterSpacing: 0.5, lineHeight: 1.1 }}>
                    Seller Guide
                </h2>
                <div
                    style={{
                        background: '#fff',
                        borderRadius: '24px',
                        boxShadow: '0 2px 16px #0001',
                        padding: '32px',
                        minWidth: '420px',
                        marginTop: 16,
                        // no width: 100% or boxSizing here, keep original card size
                    }}
                >
                    <div style={{ marginTop: '24px' }}>
                        {guidelines.map((section) => (
                            <div key={section.title}>
                                {/* <h3 style={{ fontWeight: "bold", fontSize: "1.2rem" }}>{section.title}</h3> */}
                                <ul style={{ listStyle: "none", padding: 0, color: '#23272f' }}>
                                    {section.items.map((item) => {
                                        if (typeof item === "string") {
                                            const cleanItem = item.replace(" (Guidelines)", "");
                                            return (
                                                <li key={item} style={{ margin: "12px 0", display: "flex", alignItems: "center" }}>
                                                    <img src="/content/Images/guidelinedoc.svg" alt="doc" style={{ marginRight: "12px", width: 26, height: 26, display: 'inline-block', verticalAlign: 'middle' }} />
                                                    <a
                                                        href={pdfLinks[item]}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="matrix-link"
                                                        style={{ fontWeight: 600 }}
                                                    >
                                                        {cleanItem}
                                                    </a>
                                                </li>
                                            );
                                        } else {
                                            // item with subItems
                                            const isMainGuidelines = item.label === 'Seller Guide';
                                            return (
                                                <li key={item.label} style={{ margin: "12px 0", display: "flex", flexDirection: "column" }}>
                                                    <span style={{ display: "flex", alignItems: "center" }}>
                                                        <img src="/content/Images/guidelinedoc.svg" alt="doc" style={{ marginRight: "12px", width: 26, height: 26, display: 'inline-block', verticalAlign: 'middle' }} />
                                                        {isMainGuidelines ? (
                                                            <a
                                                                href={pdfLinks[item.label]}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="matrix-link"
                                                                style={{ fontWeight: 600 }}
                                                            >
                                                                {item.label}
                                                            </a>
                                                        ) : (
                                                            <span style={{ fontWeight: "bold", color: "#23272f" }}>{item.label}</span>
                                                        )}
                                                    </span>
                                                    <ul style={{ marginLeft: "32px", marginTop: "4px", color: "#444", listStyle: isMainGuidelines ? 'disc' : 'none', paddingLeft: isMainGuidelines ? '20px' : undefined }}>
                                                        {item.subItems.map((sub) => (
                                                            <li key={sub} style={{ fontSize: "0.98rem" }}>{sub}</li>
                                                        ))}
                                                    </ul>
                                                </li>
                                            );
                                        }
                                    })}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>

    </div>
);

export default CorrespondentMatrices;